import React, { type ReactNode } from 'react';
import { RoadmapChartItemInteractionProvider } from '@atlassian/jira-software-roadmap-timeline-table-kit';
import type { InteractiveChartItem } from '@atlassian/jira-software-roadmap-timeline-table-kit/src/types';

type Props = {
	items: InteractiveChartItem[];
	children: ReactNode;
};

const EMPTY_ARRAY: Array<never> = [];

export const TableProvider = (props: Props) => {
	const { items, children } = props;

	return (
		<RoadmapChartItemInteractionProvider intervals={EMPTY_ARRAY} items={items} isDragAlongEnabled>
			{children}
		</RoadmapChartItemInteractionProvider>
	);
};
